import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Processes} from '../processes';
import {ProcessesService} from '../processes.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {UserService} from '../../../../services';
import {BranchService} from '../../../setting/branches/branch.service';
import {DepartmentsService} from '../../../setting/departments/departments.service';
import {DepartmentsShowComponent} from '../../../setting/departments/departments-show/departments-show.component';
import {UsersShowComponent} from '../../../setting/users/users-show/users-show.component';
import {BranchesShowComponent} from '../../../setting/branches/branches-show/branches-show.component';


@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule, MessagesModule,MyInputsModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        ProcessesShowComponent
    ],
    entryComponents: [
        ProcessesShowComponent
    ],
    exports: [],
    providers: [SharedService, ProcessesService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-processes-show',
    templateUrl: './processes-show.component.html',
    styleUrls: ['./processes-show.component.scss'],
    providers: [ProcessesService, ConfirmationService, MessageService]
})

export class ProcessesShowComponent implements OnInit, AfterViewInit {
    id: string;
    processes =  new Processes();
    @Input() refShow;

    statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];
    availableVal = [{'val': 1, 'title': 'Yes'}, {'val': 2, 'title': 'No'}];
    checkVal = [{'val': 1, 'title': 'Yes'}, {'val': 2, 'title': 'No'}, {'val': 3, 'title': 'Yes if rejected'}];
    isDepartment = [{'val': 0, 'title': 'User\'s Department'}, {'val': 1, 'title': 'Choose Department'}];

    applog: AppLogComponent;

    selectedActions: any[] = [];
    selectedActions_old: any[] = [];

    selectedReasons: any[] = [];
    selectedReasons_old: any[] = [];

    selectedDetails: any[] = [];
    selectedDetails_old: any[] = [];

    selectedEscalation: any[] = [];
    selectedEscalation_old: any[] = [];

    selectedScreen: any[] = [];
    selectedScreen_old: any[] = [];

    users: any[] = [];
    branches: any[] = [];
    allScreens: any[] = [];
    departments: any[] = [];
    
    @Input() scrId;
    modalRef: NgbModalRef;

    @Input() delId;
    @Input() oldData;
    @Input() newData;
    @Input() newDatap;
    @Input() modelName;

    form: FormGroup;
    private sub: any;
    msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private processesService: ProcessesService,
                private userService: UserService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                private branchService: BranchService,
                private departmentService: DepartmentsService,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        this.msgs =[];

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},

        ]);
        this.sharedservice.setModelName('processes');
        this.sharedservice.setItemShow(ProcessesShowComponent);

    }
    recordData() {
        const options: NgbModalOptions = {
            beforeDismiss: () => {
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.processes;
        modalRef.componentInstance.rowId = '';

    }

    showUser(user_id:string){
        if(user_id){
            const options: NgbModalOptions = {
                beforeDismiss: () => {
                    console.log("before dismiss");
                    return true;
                }
            };
            this.modalRef = this.modalService.open(UsersShowComponent, options);
            this.modalRef.componentInstance.scrId = user_id;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    showBranch(branch_id){
        if(branch_id){
            const options: NgbModalOptions = {
                beforeDismiss: () => {
                    console.log("before dismiss");
                    return true;
                }
            };
            this.modalRef = this.modalService.open(BranchesShowComponent, options);
            this.modalRef.componentInstance.scrId = branch_id;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    showDepartment(department_id){
        if(department_id){
            const options: NgbModalOptions = {
                beforeDismiss: () => {
                    console.log("before dismiss");
                    return true;
                }
            };
            this.modalRef = this.modalService.open(DepartmentsShowComponent, options);
            this.modalRef.componentInstance.scrId = department_id;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }

    ngAfterViewInit() {
        this.msgs =[];
        if(!this.scrId && !this.oldData && !this.scrId) {
            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');
            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/processes/edit', this.id]);
                });
            }
            if (this._deleteButton) {

                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteProcess(this.processes);
                });
            }
            if (this._newButton) {

                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/processes']);
                });

            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/processes/search']);
                });
            }
        }
    }

    ngOnInit() {
        this.msgs =[];

        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.processesService.getAllScreens(1).subscribe(
          data => {
            this.allScreens = data.screenslist;
        });

        this.userService.getAllUsers().subscribe(
          data => {
            this.users = data.userslist;
        });

        this.branchService.getAllBranches().subscribe(
          data => {
            this.branches = data.brancheslist;
        });

        this.departmentService.getAllDepartments().subscribe(
          data => {
            this.departments = data.departmentslist;
        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}),
            name: new FormControl({value: '', disabled: true}),
            status: new FormControl({value: '', disabled: true}),
            available: new FormControl({value: '', disabled: true}),
            sms_notify: new FormControl({value: '', disabled: true}),
            email_notify: new FormControl({value: '', disabled: true}),
        });

        if (this.id) {
            this.msgs =[];
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.delId = false;
            this.newDatap = true;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
            }
            this.processesService.getById(this.id).subscribe(
                processes => {
                    this.id = processes.id;
                    this.processes = processes;
                    this.selectedActions = processes.actions;
                    this.selectedReasons = processes.reasons;
                    this.selectedEscalation = processes.escalations;
                    this.selectedDetails = processes.details;
                    this.selectedScreen = processes.screens;
                    this.form.patchValue({
                        id: processes.id,
                        name: processes.name,
                        status: processes.status,
                        available: processes.available,
                        sms_notify: processes.sms_notify,
                        email_notify: processes.email_notify,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }
        if (this.scrId) {
            this.oldData = false;
            this.newData = false;
            this.delId = false;

            this.processesService.getById(this.scrId).subscribe(
                processes => {
                    this.id = processes.id;
                    this.processes = processes;
                    this.selectedActions = processes.actions;
                    this.selectedReasons = processes.reasons;
                    this.selectedEscalation = processes.escalations;
                    this.selectedDetails = processes.details;
                    this.selectedScreen = processes.screens;
                    this.form.patchValue({
                        id: processes.id,
                        name: processes.name,
                        status: processes.status,
                        available: processes.available,
                        sms_notify: processes.sms_notify,
                        email_notify: processes.email_notify,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }
        
        if(this.delId){
            this.oldData = false;
            this.newData = false;
            this.newDatap = !this.newDatap ;
            this.processesService.getTrashedById(this.delId).subscribe(
                processes => {
                    this.id = processes.id;
                    this.processes = processes;
                    this.selectedActions = processes.actions;
                    this.selectedReasons = processes.reasons;
                    this.selectedEscalation = processes.escalations;
                    this.selectedDetails = processes.details;
                    this.selectedScreen = processes.screens;
                    this.form.patchValue({
                        id: processes.id,
                        name: processes.name,
                        status: processes.status,
                        available: processes.available,
                        sms_notify: processes.sms_notify,
                        email_notify: processes.email_notify,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.processes = this.newData;

            this.selectedActions = this.newData.actions;
            this.selectedActions_old = this.oldData.actions;
            
            this.selectedReasons = this.newData.reasons;
            this.selectedReasons_old = this.oldData.reasons;
            
            this.selectedEscalation = this.newData.escalations;
            this.selectedEscalation_old = this.oldData.escalations;
            
            this.selectedDetails = this.newData.details;
            this.selectedDetails_old = this.oldData.details;
            
            this.selectedScreen = this.newData.screens;
            this.selectedScreen_old = this.oldData.screens;

            this.form.patchValue({
                id: this.newData.id,
                name: this.newData.name,
                status: this.newData.status,
                available: this.newData.available,
                sms_notify: this.newData.sms_notify,
                email_notify: this.newData.email_notify,
            });
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('management.processes.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteProcess(process: Processes) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (process) {
                    this.processesService.delete(process.id).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Delete completed')
                            });
                            setTimeout(()=>{
                                this.router.navigate(['/processes']);
                        },1000);
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));

                        }
                    );
                }
            }
        });
    }

    recoverEdit(processes: Processes) {
        this.msgs = [];
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (processes) {
                    processes.actions = JSON.stringify(this.selectedActions_old);
                    processes.reasons = JSON.stringify(this.selectedReasons_old);
                    processes.escalations = JSON.stringify(this.selectedEscalation_old);
                    processes.details = JSON.stringify(this.selectedDetails_old);
                    processes.screens = JSON.stringify(this.selectedScreen_old);
                    this.processesService.update(processes).subscribe(
                        res => {
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/processes/show', processes.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.processesService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted organization recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/processes/list']);
                        }
                    );
                }
            }
        });
    }


    showattachement(row_id: string) {
        if (row_id) {
            const options: NgbModalOptions = {
                beforeDismiss: () => {
                  return true;
                }
            };
            const modalRef = this.modalService.open(AppArcComponent, options);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.screenName = this.modelName;
        }
    }
    showHistory(row_id: string) {
        if (row_id) {
            const modalRef = this.modalService.open(AppLogComponent);
            modalRef.componentInstance.refShow = ProcessesShowComponent;
            modalRef.componentInstance.rowId = row_id;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/views/management/processes/processes-show/processes-show.component.ts